import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IUserPreferences } from 'models/user/userpreferences';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { ResultsWrapper } from 'components/PortalStructure';
import { INodeDto, IAuthContext } from 'models/common';
import { getWishlist, resetWishlistData } from 'redux/modules/user/wishlist';
import { IWishlistData, IWishlistAction } from 'models/user/wishlist';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';

interface IProps {
	wishlist?: IWishlistData;
	userPreferences?: IUserPreferences;
	location?: any;
	getWishlist?: (userId: string, isFirstLoad: boolean) => IWishlistAction;
	resetWishlistData?: () => IWishlistAction;
	t?: (key: string) => string;
	selectItem?: (item: INodeDto) => void;
	goToCard: (id: string, type: string, target: string) => void;
	dispatch?: any;
	context?: IAuthContext;
}

@connect(
	(state: IStore) => ({
		wishlist: state.wishlist,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		getWishlist: (userId: string, isFirstLoad: boolean) => dispatch(getWishlist(userId, isFirstLoad)),
		resetWishlistData: () => dispatch(resetWishlistData()),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class WishlistSearchResultsComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.getSearchResults = this.getSearchResults.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetWishlistData();
	}

	private likeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.Wishlist);
			this.props.dispatch(likes.likeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.Wishlist);
			this.props.dispatch(likes.unlikeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private loadMoreData() {
		this.getSearchResults(false);
	}

	private getSearchResults(isFirstLoad: boolean) {
		this.props.getWishlist(this.props.userPreferences.id, isFirstLoad);
	}

	private getCardTypeByNodeType(type: string) {
		let card = null;
		switch (type) {
			case c.NODE_TYPE_WARDROBE:
				card = c.NODE_TYPE_WARDROBE_ITEM_CARD;
				break;

			case c.NODE_TYPE_PRODUCT:
				card = c.NODE_TYPE_PRODUCT_ITEM_CARD;
				break;

			default:
				break;
		}
		return card;
	}

	public render() {
		if (this.props.wishlist.error) {
			return <ErrorPage {...this.props} message={this.props.wishlist.message} />;
		}

		const { items, itemsPage } = this.props.wishlist;
		const { t } = this.props;

		if (!itemsPage) {
			return '';
		}

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage ? itemsPage.totalItems > items.length : false,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		// set type to item
		const wishlistData = items.map((item: any) => {
			item.itemType = this.getCardTypeByNodeType(JSON.parse(item.entityId).type);
			return item;
		});

		const listProps: IItemCardList = {
			items: wishlistData,
			itemType: null, // wishlists can be different types
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			likeItem: this.likeItem,
			unlikeItem: this.unlikeItem,
			selectItemObject: this.props.selectItem,
			goToCard: this.props.goToCard,
			disableActions: true,
		};

		let content = null;
		if (items.length > 0) {
			content = <ItemCardList {...listProps} />;
		} else {
			content = <div className="noResultWrapper">{t('BSPortal_Common_NoResults')}</div>;
		}
		return <ResultsWrapper>{content}</ResultsWrapper>;
	}
}
const WishlistSearchResults = withAuthContext(WishlistSearchResultsComponent);
export { WishlistSearchResults };
